import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Dropdown, Menu } from 'antd';
import { AuditOutlined, DownOutlined, LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { useUser } from '../../../hooks/useUser';
import { useLoan } from '../../../stores/store';
import { LENDAPI_COMBINED_FUNNEL_FROM_PARAM, MY_APPLICATIONS_PATH } from '../../../constants';

const headerBtnStyle: React.CSSProperties = {
  fontSize: '1.3rem',
  cursor: 'pointer',
  border: 'none',
  background: 'none',
  padding: '4px',
};

interface Props {
  hasSession?: boolean;
  onLoginSuccess?: () => void;
}

const LendAPIFunnelHeaderRight: React.FC<Props> = ({ hasSession, onLoginSuccess }) => {
  const user = useUser();
  const loanStore = useLoan();
  const isAuthenticated = user && !user.isAnonymous;

  const sourceId = new URLSearchParams(window.location.search).get('source');
  const fromParam = `?from=${LENDAPI_COMBINED_FUNNEL_FROM_PARAM}${
    sourceId ? `&source=${sourceId}` : ''
  }`;

  const handleHeaderLogin = () => {
    loanStore
      .showAuthModal(true)
      .then(() => onLoginSuccess?.())
      .catch(() => {});
  };

  const userMenu = (
    <Menu>
      <Menu.Item key="my-apps">
        <Link to={`${MY_APPLICATIONS_PATH}${fromParam}`} style={{ display: 'block' }}>
          <AuditOutlined /> My Applications
        </Link>
      </Menu.Item>
      <Menu.Item key="logout">
        <Link to={`/logout${fromParam}`} style={{ display: 'block' }}>
          <LogoutOutlined /> Logout
        </Link>
      </Menu.Item>
    </Menu>
  );

  if (isAuthenticated) {
    return (
      <Dropdown overlay={userMenu} trigger={['click']}>
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
        <a
          className="combined-user-btn"
          style={headerBtnStyle}
          onClick={(e) => e.preventDefault()}
          data-testid="user-dropdown-trigger"
        >
          <UserOutlined /> <DownOutlined style={{ fontSize: '0.7rem' }} />
        </a>
      </Dropdown>
    );
  }

  if (hasSession === false) return null;

  return (
    <Button
      type="default"
      className="combined-login-btn"
      onClick={handleHeaderLogin}
      data-testid="header-login-button"
    >
      Login
    </Button>
  );
};

export default LendAPIFunnelHeaderRight;
